// Re-export the SDK's public types so consumers depend on this wrapper, never
// on `@voxhq/web-sdk` directly.
export type {
  Note,
  SessionStatus,
  StartOptions,
  UploadEventMap,
  UploadHandle,
  VoxClient,
  VoxEventMap,
} from '@voxhq/web-sdk';
export {
  truncateVoxContext,
  VOX_CONTEXT_MAX_LENGTH,
  VOX_SESSION_COMPLETED,
  VoxSdk,
} from './lib/vox-sdk';
export type { VoxSdkFactory, VoxSdkModule } from './lib/vox-sdk';
export {
  createMockVoxSdk,
  MockUploadHandle,
  MockVoxClient,
} from './lib/mock-vox-client';
export type { IMockVoxSdk } from './lib/mock-vox-client';
